const countries = require("./countries");
const currencies = require("./currencies");

module.exports = Object.assign({}, countries, currencies);
